import { Component, forwardRef } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { PortalModule } from '@angular/cdk/portal';
import { EzInputComponent } from 'src/app/shared/components/ez-input/ez-input.component';
import { EzInputDirective } from 'src/app/shared/components/ez-input/ez-input.directive';
import { SearchSelectComponent } from 'src/app/shared/components/search-select/search-select.component';
import {
  HintAddressStepAbstract
} from 'src/app/layout/common/components/order-form/step-address/hint-address-step.abstract';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-hint-address-step',
    templateUrl: './hint-address-step.component.html',
    styleUrls: ['./hint-address-step.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => HintAddressStepComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => HintAddressStepComponent),
            multi: true,
        }
    ],
  imports: [
    ReactiveFormsModule,
    EzInputComponent,
    EzInputDirective,
    PortalModule,
    SearchSelectComponent,
    AsyncPipe,
  ]
})
export class HintAddressStepComponent extends HintAddressStepAbstract {}
